import instance from "../utils/network";
import { TournamentItmResponse } from "./pub-tournament";
import { PubTournament } from "./types";

export interface CompetitionTournamentResponse {
  tournament: PubTournament;
  itm: TournamentItmResponse[];
}

export function getRunnerCompetitionTournament(): Promise<PubTournament[]> {
  return instance.get(`/nest/runner-competition-tournament/runner`);
}

export function getRunnerCompetitionTournamentById(
  id: number
): Promise<CompetitionTournamentResponse> {
  return instance.get(`/nest/runner-competition-tournament/detail/${id}`);
}
